import { useMutation, useQuery } from 'react-query';
import activationService from './Activation.service';

export function useCompanyActivationTokenValidate(activationToken?: string) {
  return useQuery(
    ['companies', 'activation-token', activationToken],
    () => activationService.validateToken(activationToken),
    {
      enabled: !!activationToken,
      retry: false,
    },
  );
}

export function useCompanyActivationLoginVerify() {
  return useMutation(activationService.verifyLogin);
}

export function useCompanyActivate() {
  return useMutation(activationService.activate);
}
